// import React from 'react'
// import Service1 from '../assets/Service1.jpeg';
// import Service2 from '../assets/Service2.jpeg';
// import Service3 from '../assets/Service3.jpeg';
// import Service4 from '../assets/Service4.jpeg';
// import Service5 from '../assets/Service5.jpeg';
// import Service6 from '../assets/Service6.jpeg';


// const MyService = () => {
//   return (
//     <>
//     {/* services section */}
// <section className='my-5'>
// <div className='container'>


//   <span className='fm-inter fw-semibold text-golden fs-5'>Services</span>
//   <p className='mt-2 about-heading'>Exclusive info</p>


// <div className='row'>

// <div className='col-lg-4 col-md-6 col-12 my-2'>
// <div className='service-card'>
//   <img src={Service1} className='img-fluid' />
// {/* <FaChartLine size={50} className='service-icon' /> */}
//   <p className='service-text mt-3'>In & Out Trade Journaling</p>
//   <p className='text-muted para-text'>One of the most powerful tools for long-term success is self-analysis. Our intelligent trade journal allows traders to record, review, and refine every trade they take.
// With minimal input—such as entry & exit prices—the system calculates: -
// •	Profit and loss
// •	Trade metrics, & more.
// </p>
// </div>
// </div>

// <div className='col-lg-4 col-md-6 col-12 my-2'>
//   <div className='service-card'>
//   <img src={Service2} className='img-fluid' />
// {/* <FaCheckDouble size={50} className='service-icon' /> */}
//   <p className='service-text mt-3'>Multiple Index Access</p>
//   <p className='text-muted para-text'>monitor multiple indices from a single platform, enabling diversified trading, faster decisions, and seamless switching between markets in real time.
//     By combining news intelligence, education, and analytics we help traders shift from reactive trading to strategic execution.
//   </p>
// </div>
// </div>

// <div className='col-lg-4 col-md-6 col-12 my-2'>
//   <div className='service-card'>
//   <img src={Service3} className='img-fluid' />
// {/* <RiGraduationCapFill size={50} className='service-icon' /> */}
//   <p className='service-text mt-3'>Educational Content</p>
//   <p className='text-muted para-text'>We offer a wide range of trading strategies for different market environments.
//     Step-by-step video explanations for easy understanding. Practical insights into entry, exit, and risk management.
//     All strategies are tested, verified, and validated by our expert team.
// </p>
// </div>  
// </div>

// <div className='col-lg-4 col-md-6 col-12 my-2'>
//   <div className='service-card'>
//   <img src={Service4} className='img-fluid' />
// {/* <SiMarketo size={50} className='service-icon' /> */}
//   <p className='service-text mt-3'>Latest News & Market Insights</p>
//   <p className='text-muted para-text'>We compare current & previous data, allowing traders to understand how expectations differ from actual outcomes. Data-backed analysis explaining past price reactions.
//     Anticipated market impact based on expert evaluation & statistical patterns.
//   </p>
// </div>  
// </div>

// <div className='col-lg-4 col-md-6 col-12 my-2'>
//   <div className='service-card'>
//   <img src={Service5} className='img-fluid' />
// {/* <SiLivechat size={50} className='service-icon' /> */}
//   <p className='service-text mt-3'>Live Chat & Real-Time Idea Exchange</p>
//   <p className='text-muted para-text'>Within the community, traders can:- Share views on current market movements. Discuss trade setups and technical perspectives.
//     Learn from collective experience and diverse approaches. Gain reassurance and confidence through collaboration.
// </p>
// </div>  
// </div>

// <div className='col-lg-4 col-md-6 col-12 my-2'>
//   <div className='service-card'>
//   <img src={Service6} className='img-fluid' />
// {/* <MdDashboard size={50} className='service-icon' /> */}
//   <p className='service-text mt-3'>Digital Dashboard</p>
//   <p className='text-muted para-text'>View performance analytics, and record data in one digital dashboard designed for clarity, speed, and informed decision-making.
//     mapped high-probability buy and sell zones helping traders avoid emotional decisions and react with confidence to evolving market conditions.
//   </p>
// </div>  
// </div>


// </div>
// {/* row ends */}


// </div>
// </section>
// {/* services section ends */}

//     </>
//   )
// }

// export default MyService
import React, { useState } from 'react';
import Service1 from '../assets/Service1.jpeg';
import Service2 from '../assets/insight-1.jpeg';
import Service3 from '../assets/Service3.jpeg';
import Service4 from '../assets/Service4.jpeg';
import Service5 from '../assets/Service5.jpeg';
import Service6 from '../assets/Service6.jpeg';

const servicesData = [
  {
    img: Service1,
    title: 'In & Out Trade Journaling',
    text: `One of the most powerful tools for long-term success is self-analysis. Our intelligent trade journal allows traders to record, review, and refine every trade they take.

    With minimal input—such as entry & exit prices—the system calculates:-
• Profit and loss
• Trade metrics, & more.`,
  },
  {
    img: Service2,
    title: 'Market Insights',
    text: `Monitor multiple indices from a single platform, enabling diversified trading, faster decisions, and seamless switching between markets in real time.
By combining news intelligence, education, and analytics we help traders shift from reactive trading to strategic execution.

You gain access to:-
•	Key market rise and fall zones
•	Professionally calculated support and resistance levels
•	Clearly mapped high-probability buy and sell zones
•	Forward-looking strategies for upcoming market sessions
Every insight is designed to support planned execution, helping traders avoid emotional decisions and react with confidence to evolving market conditions.
`,
  },
  {
    img: Service3,
    title: 'Educational Content',
    text: `Successful trading requires a strategy that aligns with your personality and market conditions. Our platform provides an extensive library of educational video content, enabling traders to learn, practice, and apply proven methodologies.

    What we offer:-
•	A wide range of trading strategies for different market environments
•	Step-by-step video explanations for easy understanding
•	Practical insights into entry, exit, and risk management
•	All strategies are tested, verified, and validated by our expert team
This ensures traders don’t rely on random signals but trade with structure, logic, and confidence.`,
  },
  {
    img: Service4,
    title: 'Latest News',
    text: `Markets react instantly to economic releases, geopolitical developments, and global financial events. We ensure you never miss what matters.

    Our platform delivers real-time market, economic, and geopolitical news, enriched with professional analysis that goes beyond headlines. We compare current and previous data, allowing traders to clearly understand how expectations differ from actual outcomes.

Additionally, we provide:-
•	Historical market behaviour during similar events
•	Data-backed analysis explaining past price reactions
•	Anticipated market impact based on expert evaluation and statistical patterns
•	Clear classification of positive or negative sentiment
This approach helps traders position themselves before volatility unfolds, reducing uncertainty and improving timing.`,
  },
  {
    img: Service5,
    title: 'Live Chat & Real-Time Idea Exchange',
    text: `Trading can be isolating, but growth accelerates in the right environment. Our platform includes live chat sessions where traders interact with each other in real time.

    Within the community, traders can:-
•	Share views on current market movements
•	Discuss trade setups and technical perspectives
•	Learn from collective experience and diverse approaches
•	Gain reassurance and confidence through collaboration
This creates a supportive ecosystem where traders continuously learn, adapt, and improve.`,
  },
  {
    img: Service6,
    title: 'Digital Dashboard',
    text: `One of the most powerful tools for long-term success is self-analysis. Our intelligent trade journal allows traders to record, review, and refine every trade they take.

    With minimal input—such as entry and exit prices—the system automatically calculates:-
•	Profit and loss
•	Risk-to-reward ratios
•	Trade performance metrics

Over time, a comprehensive performance dashboard is generated, providing deep insights such as:-
•	Overall and strategy-specific success rates
•	Performance trends by day of the week
•	Risk management consistency
•	Behavioral patterns affecting profitability
This data-driven feedback helps traders identify mistakes, improve discipline, and gain emotional control—the true foundation of professional trading.`,
  },
];


const renderTextWithBreaks = (text) => {
  return text.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ));
};


const MyService = () => {
  // State to track which card is expanded
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <>
      <section className='my-5'>
        <div className='container'>
          <span className='fm-inter fw-semibold text-golden fs-5'>Services</span>
          <p className='mt-2 about-heading'>Exclusive info</p>

          <div className='row'>
            {servicesData.map((service, index) => (
              <div className='col-lg-4 col-md-6 col-12 my-2' key={index}>
                <div className='service-card'>
                  <img src={service.img} className='img-fluid' alt={service.title} />
                  <p className='service-text mt-3'>{service.title}</p>
<p className='text-muted para-text'>
  {expandedIndex === index
    ? renderTextWithBreaks(service.text)
    : renderTextWithBreaks(
        service.text.length > 150
          ? service.text.slice(0, 150) + '...'
          : service.text
      )}
</p>
                  {service.text.length > 150 && (
                    <button
                      className='btn btn-link p-0'
                      onClick={() => toggleExpand(index)}
                    >
                      {expandedIndex === index ? 'Show Less' : 'Know More'}
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default MyService;
